import { CustomAvatarProps, Spinner, TmdxAvatar } from '@ds';
import { Uuid } from '@/api/types';
import { useOcsConsoleByIdQuery } from '@/queries/ocs-consoles';
import { specialistCssStyles, SpecialistStylesStyle } from '../Base/specialistStyles';
import { MiniCard } from '../Base/MiniCard';
import { OrganType } from '@/api/apis/case';
import { getColorsByOrganType } from '@/utils/helpers';

type DeviceCardProps = {
  organType: OrganType;
  deviceId: Uuid;
  avatarProps?: CustomAvatarProps;
};

export const DeviceCard = ({ organType, deviceId, avatarProps }: DeviceCardProps) => {
  const { data: consoleData } = useOcsConsoleByIdQuery(deviceId, { withDeleted: true });
  const colors = getColorsByOrganType(organType);

  return (
    <MiniCard
      classNames={colors.bg80}
      label={consoleData ? consoleData?.ocsConsoleName : <Spinner size="sm" color="current" />}
      value={consoleData?.fullSerialNumber}
      leftItem={
        <TmdxAvatar type="device" size="md" src={consoleData?.logoPath} className="mr-2 w-8 h-8" {...avatarProps} />
      }
      rightItem={null}
      cssStyles={specialistCssStyles[SpecialistStylesStyle.base]}
    />
  );
};
